import { BaseProvider } from "./base.provider";
import { injectScript } from "../utilities/dom-mutations";
import { jsonParser } from "../utilities/parsers";
export class GlobalbetProvider extends BaseProvider {
    initGame() {
        const { clientScriptData } = this.launchData;
        const scriptData = jsonParser(clientScriptData);
        if (window.location.host.includes("localhost"))
            this.scriptUrl = `https://www.betway.co.tz${scriptData.launchUrl}`;
        this.scriptUrl = `https://www.betway.co.tz${scriptData.launchUrl}`;
        const container = document.getElementById(this.elementId);
        window.widgetAdapter.registerVirtualSports(container, this.scriptUrl, {
            sticky: false,
            fixedHeader: false,
            fixedFooter: false,
        });
    }
    init() {
        const { externalJsScripts } = this.launchData;
        const mappedScripts = externalJsScripts.map((ejs, index) => {
            return {
                hid: `globalbetexternalscript-${index}`,
                src: ejs.url,
                callback: () => this.initGame(),
            };
        });
        injectScript(mappedScripts);
    }
}
